import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import ScrollToTop from '../components/ScrollToTop';
import Swal from "sweetalert2";
const MyAccount: React.FC = () => {
 const [menuOpen, setMenuOpen] =  useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [editMode, setEditMode] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [profile, setProfile] = useState({
    firstName: 'Priya',
    lastName: 'Sharma',
    email: 'priya@email.com',
    phone: '+91 98765 43210',
    dob: '1995-08-19',
    gender: 'Female',
  });

  const [avatar, setAvatar] = useState(
    '/assets/img/author/author-1-1.png'
  );

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };



const saveProfile = (e: React.FormEvent) => {
  e.preventDefault();

  setEditMode(false);

 Swal.fire({
  icon: "success",
  title: "Success!",
  text: "Profile updated successfully!",
  confirmButtonText: "Okay",
  background: "#fff",
  color: "#000",
  confirmButtonColor: "#b8400e",
  iconColor: "#b8400e", // custom icon color
});
};

  const previewAvatar = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {

    if (e.target.files && e.target.files[0]) {

      const reader = new FileReader();

      reader.onload = (event) => {
        setAvatar(event.target?.result as string);
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">

        <Header />

        {/* CSS */}
        <link
          rel="stylesheet"
          href="/assets/css/Myaccount.css"
        />

        {/* Breadcumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >

          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container">

            <div className="breadcumb-content">

              <h1 className="breadcumb-title">
                My Account
              </h1>

              <div className="breadcumb-menu-wrap">

                <ul className="breadcumb-menu">

                  <li>
                    <Link to="/">Home</Link>
                  </li>

                  <li>My Account</li>

                </ul>

              </div>

            </div>

          </div>

        </div>

        {/* Account Section */}
        <section className="space-top space-extra-bottom">

          <div className="container">

            <div className="row g-4">

              {/* Sidebar */}
              <div className="col-lg-3">

                <div className="account-sidebar">

                  {/* USER */}
                  <div className="account-user text-center">

                    <div className="account-avatar">

                      <img
                        src={avatar}
                        alt="User"
                      />

                      <label
                        htmlFor="avatarUpload"
                        className="avatar-edit-btn"
                      >

                        <i className="far fa-camera"></i>

                        <input
                          type="file"
                          id="avatarUpload"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={previewAvatar}
                        />

                      </label>

                    </div>

                    <h5>
                      {profile.firstName} {profile.lastName}
                    </h5>

                    <p>
                      {profile.email}
                    </p>

                  </div>

                  {/* NAVIGATION */}
                  <ul className="account-nav">

                    <li>

                      <button
                        className={`account-nav__link ${
                          activeTab === 'profile'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() =>
                          setActiveTab('profile')
                        }
                      >

                        <i className="far fa-user"></i>
                        My Profile

                      </button>

                    </li>

                    <li>

                      <button
                        className={`account-nav__link ${
                          activeTab === 'orders'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() =>
                          setActiveTab('orders')
                        }
                      >

                        <i className="far fa-shopping-bag"></i>
                        My Orders

                      </button>

                    </li>

                    <li>

                      <Link
                        to="/wishlist"
                        className="account-nav__link"
                      >

                        <i className="far fa-heart"></i>
                        Wishlist

                      </Link>

                    </li>

                    <li>

                      <button
                        className={`account-nav__link ${
                          activeTab === 'address'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() =>
                          setActiveTab('address')
                        }
                      >

                        <i className="far fa-map-marker-alt"></i>
                        Addresses

                      </button>

                    </li>

                    <li>

                      <button
                        className={`account-nav__link ${
                          activeTab === 'password'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() =>
                          setActiveTab('password')
                        }
                      >

                        <i className="far fa-lock"></i>
                        Change Password

                      </button>

                    </li>

                    <li>

                      <Link
                        to="/admin/login"
                        className="account-nav__link logout-link"
                      >

                        <i className="far fa-sign-out"></i>
                        Logout

                      </Link>

                    </li>

                  </ul>

                </div>

              </div>

              {/* Main Content */}
              <div className="col-lg-9">

                {/* PROFILE TAB */}
                {activeTab === 'profile' && (

                  <div className="account-card">

                    <div className="account-card__head d-flex justify-content-between align-items-center">

                      <h3 className="account-card__title">
                        Personal Information
                      </h3>

                      <button
                        className="vs-btn style2"
                        onClick={() =>
                          setEditMode(!editMode)
                        }
                      >

                        <i className="far fa-edit me-1"></i>

                        {editMode
                          ? 'Editing...'
                          : 'Edit Profile'}

                      </button>

                    </div>

                    <form onSubmit={saveProfile}>

                      <div className="row g-3">

                        <div className="col-md-6">

                          <label className="form-label">
                            First Name
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={profile.firstName}
                            onChange={handleChange}
                            readOnly={!editMode}
                          />

                        </div>

                        <div className="col-md-6">

                          <label className="form-label">
                            Last Name
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={profile.lastName}
                            onChange={handleChange}
                            readOnly={!editMode}
                          />

                        </div>

                        <div className="col-md-6">

                          <label className="form-label">
                            Email Address
                          </label>

                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={profile.email}
                            onChange={handleChange}
                            readOnly={!editMode}
                          />

                        </div>

                        <div className="col-md-6">

                          <label className="form-label">
                            Phone Number
                          </label>

                          <input
                            type="tel"
                            className="form-control"
                            name="phone"
                            value={profile.phone}
                            onChange={handleChange}
                            readOnly={!editMode}
                          />

                        </div>

                        <div className="col-md-6">

                          <label className="form-label">
                            Date of Birth
                          </label>

                          <input
                            type="date"
                            className="form-control"
                            name="dob"
                            value={profile.dob}
                            onChange={handleChange}
                            readOnly={!editMode}
                          />

                        </div>

                        <div className="col-md-6">

                          <label className="form-label">
                            Gender
                          </label>

                          <select
                            className="form-select"
                            name="gender"
                            value={profile.gender}
                            onChange={handleChange}
                            disabled={!editMode}
                          >

                            <option>Female</option>
                            <option>Male</option>
                            <option>Prefer not to say</option>

                          </select>

                        </div>

                        {editMode && (

                          <div className="col-12">

                            <button
                              type="submit"
                              className="vs-btn me-2"
                            >
                              Save Changes
                            </button>

                            <button
                              type="button"
                              className="vs-btn style2 Cancel-btn"
                              onClick={() =>
                                setEditMode(false)
                              }
                            >
                              Cancel
                            </button>

                          </div>

                        )}

                      </div>

                    </form>

                  </div>

                )}

                {/* ORDERS TAB */}
                {activeTab === 'orders' && (

                  <div className="account-card">

                    <div className="account-card__head">

                      <h3 className="account-card__title">
                        My Orders
                      </h3>

                    </div>

                    <div className="orders-table-wrap">

                      <table className="orders-table">

                        <thead>

                          <tr>
                            <th>Order #</th>
                            <th>Date</th>
                            <th>Items</th>
                            <th>Total</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>

                        </thead>

                        <tbody>

                          <tr>

                            <td>#NS-1045</td>
                            <td>20 Apr 2026</td>
                            <td>Ring + Earrings</td>
                            <td>₹11,300</td>

                            <td>

                              <span className="order-status delivered">
                                Delivered
                              </span>

                            </td>

                            <td>

                              <Link
                                to="/my-orders"
                                className="order-view-btn"
                              >
                                View
                              </Link>

                            </td>

                          </tr>

                          <tr>

                            <td>#NS-1038</td>
                            <td>05 Apr 2026</td>
                            <td>Gold Necklace</td>
                            <td>₹8,200</td>

                            <td>

                              <span className="order-status shipped">
                                Shipped
                              </span>

                            </td>

                            <td>

                              <Link
                                to="/my-orders"
                                className="order-view-btn"
                              >
                                View
                              </Link>

                            </td>

                          </tr>

                        </tbody>

                      </table>

                    </div>

                  </div>

                )}

                {/* ADDRESS TAB */}
                {activeTab === 'address' && (

                  <div className="account-card">

                    <div className="account-card__head d-flex justify-content-between align-items-center">

                      <h3 className="account-card__title">
                        Saved Addresses
                      </h3>

                      <button
                        className="vs-btn style2"
                        onClick={() =>
                          setShowForm(!showForm)
                        }
                      >

                        <i className="far fa-plus me-1"></i>

                        {showForm
                          ? 'Close Form'
                          : 'Add New'}

                      </button>

                    </div>

                    {/* SAVED ADDRESS */}
                    <div className="row g-3">

                      <div className="col-md-6">

                        <div className="address-card">

                          <div className="address-card__badge">
                            Default
                          </div>

                          <p>
                            <strong>
                              Priya Sharma
                            </strong>
                          </p>

                          <p>
                            123 MG Road,
                            Koramangala
                            <br />
                            Bengaluru,
                            Karnataka - 560034
                            <br />
                            India
                          </p>

                          <p>
                            +91 98765 43210
                          </p>

                        </div>

                      </div>

                    </div>

                    {/* ADD NEW ADDRESS FORM */}
                    {showForm && (

                      <div className="new-address-form mt-4">

                        <h4 className="mb-3">
                          Add New Address
                        </h4>

                        <div className="row g-3">

                          <div className="col-md-6">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Full Name"
                            />

                          </div>

                          <div className="col-md-6">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Phone Number"
                            />

                          </div>

                          <div className="col-12">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address Line 1"
                            />

                          </div>

                          <div className="col-12">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address Line 2"
                            />

                          </div>

                          <div className="col-md-4">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="City"
                            />

                          </div>

                          <div className="col-md-4">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="State"
                            />

                          </div>

                          <div className="col-md-4">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="PIN Code"
                            />

                          </div>

                          <div className="col-12 mt-3">

                            <button className="vs-btn me-2">
                              Save Address
                            </button>

                            <button
                              type="button"
                              className="vs-btn style2 px-5"
                              onClick={() =>
                                setShowForm(false)
                              }
                            >
                              Cancel
                            </button>

                          </div>

                        </div>

                      </div>

                    )}

                  </div>

                )}

                {/* PASSWORD TAB */}
                {activeTab === 'password' && (

                  <div className="account-card">

                    <div className="account-card__head">

                      <h3 className="account-card__title">
                        Change Password
                      </h3>

                    </div>

                    <form
                      className="row g-3"
                      style={{ maxWidth: '480px' }}
                    >

                      <div className="col-12">

                        <label className="form-label">
                          Current Password
                        </label>

                        <input
                          type="password"
                          className="form-control"
                          placeholder="••••••••"
                        />

                      </div>

                      <div className="col-12">

                        <label className="form-label">
                          New Password
                        </label>

                        <input
                          type="password"
                          className="form-control"
                          placeholder="Min. 8 characters"
                        />

                      </div>

                      <div className="col-12">

                        <label className="form-label">
                          Confirm New Password
                        </label>

                        <input
                          type="password"
                          className="form-control"
                          placeholder="Re-enter new password"
                        />

                      </div>

                      <div className="col-12">

                        <button
                          type="submit"
                          className="vs-btn"
                        >
                          Update Password
                        </button>

                      </div>

                    </form>

                  </div>

                )}

              </div>

            </div>

          </div>

        </section>

        <Footer />

      </main>

      <ScrollToTop />

    </>
  );
};

export default MyAccount;